/**
 * Cliente API — Módulo de Autenticación (Paso 5.7)
 */

import { apiClient } from '@/config/api';
import {
  LoginCredencialesRequest,
  LoginRespuestaDTO,
  MfaChallengeVerifyRequest,
  OtpWhatsappSolicitarRequest,
  OtpWhatsappSolicitarResponse,
  OtpWhatsappVerificarRequest,
} from '../types/auth.types';

export const authApi = {
  async loginPorCredenciales(payload: LoginCredencialesRequest): Promise<LoginRespuestaDTO> {
    const res = await apiClient.post<LoginRespuestaDTO>('/auth/login', payload);
    return res.data;
  },

  async verificarDesafioMfa(payload: MfaChallengeVerifyRequest): Promise<LoginRespuestaDTO> {
    const res = await apiClient.post<LoginRespuestaDTO>('/auth/mfa/challenge', payload);
    return res.data;
  },

  async solicitarOtpWhatsapp(
    payload: OtpWhatsappSolicitarRequest
  ): Promise<OtpWhatsappSolicitarResponse> {
    const res = await apiClient.post<OtpWhatsappSolicitarResponse>('/auth/otp/solicitar', payload);
    return res.data;
  },

  async verificarOtpWhatsapp(payload: OtpWhatsappVerificarRequest): Promise<LoginRespuestaDTO> {
    const res = await apiClient.post<LoginRespuestaDTO>('/auth/otp/verificar', payload);
    return res.data;
  },
};
